var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RecurringIcon_svg__clip0_6770_7502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5V4a1.5 1.5 0 011.5-1.5H9m0 0L7.5 1M9 2.5L7.5 4M9 5.5V7a1.5 1.5 0 01-1.5 1.5H1m0 0L2.5 10M1 8.5L2.5 7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RecurringIcon_svg__clip0_6770_7502"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v11H0z"
  })))));
}
export default SvgRecurringIcon;